import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });
const lang = () => localStorage.getItem("mfc_lang") || "en";
http.interceptors.request.use((cfg) => ({ ...cfg, params: { ...(cfg.params || {}), lang: lang() } }));

export const TOKEN_KEY = "mfc_token";
export const pdfUrl = (token, type) => `${API}/results/${token}/pdf?type=${type}&lang=${lang()}`;
export const shareUrl = (token) => `${window.location.origin}/results/${token}`;

export const CLUSTER_COLORS = {};

export const levelWord = (v) => (v >= 80 ? "Very strong" : v >= 65 ? "Strong" : v >= 45 ? "Moderate" : "Developing");
